export const PROGRESS_BARS = {
  LINEAR: 'LINEAR',
  LINEAR_WITH_DOTS: 'LINEAR_WITH_DOTS',
  LINEAR_WITH_DESCRIPTION: 'LINEAR_WITH_DESCRIPTION',
}
